import styled from '@emotion/styled';

export const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 42px;
  max-width: 1070px;
  margin: 0 auto;
  padding: 24px 16px;
  @media (min-width: 800px) {
    padding: 30px;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media (min-width: 800px) {
    display: grid;
    grid-template-areas:
      'header header header'
      'nav content content';
    grid-template-columns: 180px 1fr;
  }
`;

export const Content = styled.main`
  width: 1fr;
`;

export const TestModeBadge = styled.div`
  background-color: #ffe7a5;
  color: #333;
  padding: 0.75rem;
  border-radius: 12px;
  font-size: 1.25rem;
  width: 100%;
  text-align: center;
  margin-bottom: 22px;
`;
